import { useState } from 'react';

export function useForceUpdate() {
  // eslint-disable-next-line no-unused-vars
  const [_, setValue] = useState(0);
  return () => {
    setValue(value => value + 1);
  };
}



// WEBPACK FOOTER //
// ./src/redux/opentok/hooks/useForceUpdate.js